<div *ngIf="!isLoading">
	<div class="mb-xxxs br-md card">
		<div
			class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md"
			[formGroup]="registrationForm"
		>
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">Informações básicas</span>
			</div>
			<div class="d-f line">
				<mat-form-field class="mr-xxxs col-1" title="CPF" appearance="outline">
					<mat-label>CPF</mat-label>
					<input
						type="text"
						matInput
						placeholder="CPF"
						formControlName="cpf"
						id="spc-{{ inputId }}"
						[mask]="cpfMask"
						(blur)="onCpfBlur()"
					/>
					<mat-error
						*ngIf="
							registrationForm.get('cpf')?.hasError('pattern') &&
							!registrationForm.get('cpf')?.hasError('required') &&
							!registrationForm.get('cpf')?.hasError('minlength')
						"
					>
						Digite um CPF válido
					</mat-error>
					<mat-error
						*ngIf="
							registrationForm.get('cpf')?.hasError('minlength') &&
							!registrationForm.get('cpf')?.hasError('pattern') &&
							!registrationForm.get('cpf')?.hasError('required')
						"
					>
						CPF já cadastrado
					</mat-error>
					<mat-error *ngIf="registrationForm.get('cpf')?.hasError('required')">
						É necessário digitar o cpf
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="mr-xxxs col-2 mob-va"
					title="Nome completo"
					appearance="outline"
				>
					<mat-label>Nome Completo</mat-label>
					<input
						type="text"
						matInput
						placeholder="Nome completo"
						formControlName="name"
						id="snf-{{ inputId }}"
					/>
					<mat-error *ngIf="registrationForm.get('name')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field
					class="mr-xxxs col-1"
					title="Telefone"
					appearance="outline"
				>
					<mat-label>Telefone</mat-label>
					<input
						type="text"
						matInput
						placeholder="Telefone"
						formControlName="phone"
						id="spp-{{ inputId }}"
						mask="{{ phoneMask(registrationForm.get('phone')?.value) }}"
					/>
					<mat-error
						*ngIf="
							registrationForm.get('phone')?.hasError('pattern') &&
							!registrationForm.get('phone')?.hasError('required')
						"
					>
						Digite um telefone válido
					</mat-error>
					<mat-error
						*ngIf="registrationForm.get('phone')?.hasError('required')"
					>
						Campo obrigatório
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="mr-xxxs col-2 mob-va"
					title="E-mail"
					appearance="outline"
				>
					<mat-label>E-mail</mat-label>
					<input
						type="text"
						matInput
						placeholder="E-mail"
						formControlName="email"
						id="sne-{{ inputId }}"
						(blur)="onEmailBlur()"
					/>
					<mat-error
						*ngIf="
							registrationForm.get('email')?.hasError('email') &&
							!registrationForm.get('email')?.hasError('required')
						"
					>
						Digite um email válido
					</mat-error>
					<mat-error
						*ngIf="
							registrationForm.get('email')?.hasError('minlength') &&
							!registrationForm.get('email')?.hasError('pattern') &&
							!registrationForm.get('email')?.hasError('required')
						"
					>
						Email já cadastrado
					</mat-error>
					<mat-error
						*ngIf="registrationForm.get('email')?.hasError('required')"
					>
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
		</div>
	</div>
	<div class="mb-xxxs br-md card" *ngIf="userType !== 'inativo'">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">Grupos de usuários</span>
			</div>
			<p class="mr-xxxs mb-xxs">
				Selecione um grupo ou grupos para esse usuário. Atenção: os grupos de
				admins contêm permissões privilegiadas
			</p>
			<div class="d-f line">
				<mat-form-field
					class="c-p col-2"
					title="Grupos"
					appearance="outline"
					(click)="openOrganizationGroupsModal()"
				>
					<mat-label>Grupos</mat-label>
					<input
						type="text"
						matInput
						class="c-p"
						placeholder="Grupos"
						id="sog-{{ inputId }}"
						[value]="groupsInput"
						(focus)="gpick.focus()"
					/>
					<button matSuffix mat-icon-button aria-label="Open groups dialog">
						<mat-icon>arrow_drop_down</mat-icon>
					</button>
				</mat-form-field>
				<input #gpick type="text" class="picker" />
			</div>
		</div>
	</div>
	<div class="mb-xxxs br-md card" *ngIf="userType !== 'inativo'">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">Organizações</span>
			</div>
			<p class="mr-xxxs mb-xxs">
				Selecione as organizações que usuário terá acesso. Apenas usuários do
				grupo Operadores podem acessar outras organizações
			</p>
			<div class="d-f mt-xxs line">
				<mat-form-field
					title="Organizações"
					appearance="outline"
					class="{{ isDisabledOrganizationModal ? '' : 'c-p' }} col-2"
					(click)="openOrganizationListModal()"
				>
					<mat-label>Organizações</mat-label>
					<input
						type="text"
						matInput
						placeholder="Organizações"
						id="sol-{{ inputId }}"
						class="{{ isDisabledOrganizationModal ? '' : 'c-p' }}"
						[disabled]="isDisabledOrganizationModal"
						[value]="organizationsInput"
						(focus)="opick.focus()"
					/>
					<button
						matSuffix
						mat-icon-button
						aria-label="Open organizations dialog"
					>
						<mat-icon>arrow_drop_down</mat-icon>
					</button>
				</mat-form-field>
				<input #opick type="text" class="picker" />
				<mat-checkbox
					color="primary"
					class="mt-xxs ml-xxxs col-1"
					*ngIf="isSanusOrganization"
					[checked]="registrationForm.get('sanus_partner')?.value"
					(change)="changeSanusPartner($event.checked)"
				>
					<span class="lh-lg">Ocultar dados da Sanus</span>
				</mat-checkbox>
			</div>
		</div>
	</div>
	<div class="mb-xxxs br-md card" *ngIf="userType === 'ativo'">
		<div
			class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md"
			[formGroup]="configurationForm"
		>
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">
					Configurações de usuários
				</span>
			</div>
			<p class="gray">
				Atenção: ao inativar um usuário ele não poderá mais logar na plataforma
			</p>
			<div class="d-f jc-sb ai-c w-100 mt-xs mb-xxxs">
				<p>Usuário ativo</p>
				<mat-slide-toggle
					class="mr-xxxs"
					color="primary"
					formControlName="active"
				></mat-slide-toggle>
			</div>
			<div class="mt-xxxs mb-xxxs" *ngIf="userId.length">
				<button
					mat-stroked-button
					color="primary"
					[disabled]="!isEnabledResetPassword"
					(click)="onPasswordReset()"
				>
					Resetar senha do usuário
				</button>
			</div>
		</div>
	</div>
	<div class="d-f jc-fe mb-huge">
		<button
			mat-flat-button
			color="primary"
			[disabled]="isDisabledSaveButton()"
			(click)="onSubmit()"
		>
			Salvar
		</button>
	</div>
</div>
<div class="d-f jc-c ai-c w-100 mt-giant loader" *ngIf="isLoading">
	<mat-spinner diameter="20"></mat-spinner>
</div>
